import Assets from './assets';
import assetOperationalComponent from './operationalComponent';
import assetPageSpecificActions from './PageActions/assetPageActions';
import { nameSpace as assetNS } from './Modules/nameSpace';
import reducers, { reducerKey } from './Reducers/assetReducers';
import * as assetSelectors from './Selectors/assetSelectors';
import { actions as assetGridActions } from './Modules/dataGridTable';
import { actions as assetFilterActions } from './Modules/filters';
import { actions as userAssigneeListActions } from './Modules/userAssigneeList';
import { isEmpty } from 'lodash';

export {
  Assets,
  reducers,
  reducerKey,
  assetSelectors,
  assetGridActions,
  assetFilterActions,
  assetNS,
  assetOperationalComponent,
  assetPageSpecificActions,
  userAssigneeListActions,
};

export const getAssetName = asset => {
  if (isEmpty(asset)) return '';
  let t = asset.type.name; //mandatory
  if (asset.type.assetTypeId) {
    t = `(${asset.type.assetTypeId}) ${asset.type.name}`;
  }
  let a = asset.name; //mandatory
  if (asset.type.assetTypeId) {
    a = `(${asset.assetId}) ${asset.name}`;
  }
  return `${a}: ${t}`;
};
